export enum cardTypes {
	VISA = 'visa',
	AMEX = 'american_express',
	MASTERCARD = 'MasterCard',
	DISCOVER = 'discorver',
	DINERS = 'diners_club',
	JCB = 'jcb',
	CHINA_UNION_PAY = 'china_union_pay',
	ELO = 'elo',
	HIPERCARD = 'hipercard'
}

export function creditCardType(cardNumber: string) {
	const amex = new RegExp('^3[47][0-9]{13}$')
	const visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$')
	const cup1 = new RegExp('^62[0-9]{14}[0-9]*$')
	const cup2 = new RegExp('^81[0-9]{14}[0-9]*$')

	const mastercard = new RegExp('^5[1-5][0-9]{14}$')
	const mastercard2 = new RegExp('^2[2-7][0-9]{14}$')

	const disco1 = new RegExp('^6011[0-9]{12}[0-9]*$')
	const disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$')
	const disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$')

	const diners = new RegExp('^3[0689][0-9]{12}[0-9]*$')
	const jcb = new RegExp('^35[0-9]{14}[0-9]*$')

	const elo = new RegExp(
		'^(?:401178|401179|431274|438935|451416|457393|457631|457632|504175|627780|636297|636368|655000|655001|651652|651653|651654|650485|650486|650487|650488|506699|5067[0-6][0-9]|50677[0-8]|509d{3})d{10}$'
	)

	const cc = cardNumber?.replaceAll(' ', '')

	const hiper = new RegExp('/^(606282d{10}(d{3})?)|(3841d{15})$/')

	if (visa.test(cc)) {
		return cardTypes.VISA
	}
	if (amex.test(cc)) {
		return cardTypes.AMEX
	}
	if (mastercard.test(cc) || mastercard2.test(cc)) {
		return cardTypes.MASTERCARD
	}
	if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
		return cardTypes.DISCOVER
	}
	if (diners.test(cc)) {
		return cardTypes.DINERS
	}
	if (jcb.test(cc)) {
		return cardTypes.JCB
	}
	if (cup1.test(cc) || cup2.test(cc)) {
		return cardTypes.CHINA_UNION_PAY
	}
	if (elo.test(cc)) {
		return cardTypes.ELO
	}
	if (hiper.test(cc)) {
		return cardTypes.HIPERCARD
	}
	return ''
}

// Function received from Rene
export function validateCreditCard(value: string) {
	// Accept only digits, dashes or spaces
	if (/[^0-9-\s]+/.test(value)) return false

	// The Luhn Algorithm. It's so pretty.
	let nCheck = 0,
		bEven = false
	value = value.replace(/\D/g, '')

	for (var n = value.length - 1; n >= 0; n--) {
		var cDigit = value.charAt(n),
			nDigit = parseInt(cDigit, 10)

		if (bEven && (nDigit *= 2) > 9) nDigit -= 9

		nCheck += nDigit
		bEven = !bEven
	}

	return nCheck % 10 === 0
}
